import {
  DataTable,
  FormInput,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useListing from "./useListing";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { SEARCH_CRITERIA, SEARCH_TYPE, searchType } from "./consts";

const Listing = () => {
  const {
    breadcrumbData,
    columns,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    isDocLoading,
    documentList,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isDocRefetching,
    form,
    onSubmit,
    requiredFields,
    onClear,
    communityDetail,
    onBackClick,
    currentFinanceYear
  } = useListing();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={<span>Customer Clearing Document - {communityDetail?.name} <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>}
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
          {/* {isMobile && <Button className="px-2">+ Add Budget</Button>} */}
        </div>
      </div>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px] mb-[30px]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
              <FormSelect
                name={SEARCH_TYPE}
                control={form.control}
                label="Search Type"
                placeholder="Please select"
                error={errors[SEARCH_TYPE]?.message}
                isRequired={requiredFields.includes(SEARCH_TYPE)}
                options={searchType}
              />
              <FormInput
                name={SEARCH_CRITERIA}
                control={form.control}
                label="Search Criteria"
                placeholder="Please enter"
                error={errors[SEARCH_CRITERIA]?.message}
                isRequired={requiredFields.includes(SEARCH_CRITERIA)}
              />
              <div className="flex flex-row justify-end gap-3 pt-3">
                <Button type="submit">Search</Button>
                <Button variant="outline" type="button" onClick={onClear}>
                  Clear
                </Button>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>

      {/* Responsive Table */}
      {isDocLoading || isDocRefetching ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={(documentList?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(documentList?.total / pageSize)}
            totalRecords={documentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default Listing;
